import React from 'react';
import ButtonsSearch from '../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import InputCheckBox from '../../../../../../components/NovoSistema/InputCheckBox';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function FluxoDeCaixaSearch() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisas</h3>
        <div>
          <WrapperInputsNewSystem>
            <InputDate title="Período Inicial" id="PeriodoInicial" widthPercentage="20%" />
            <InputDate title="Período Final" id="PeriodoFinal" widthPercentage="20%" />
            <div>
              <label>Tipo</label>
              <br />
              <input type="radio" id="analitico" name="tipo" value="Analítico" />
              <label htmlFor="analitico">Analítico</label>
              <input type="radio" id="sintetico" name="tipo" value="Sintético" />
              <label htmlFor="sintetico">Sintético</label>
            </div>
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Conta Bancária"
              id="ContaBancaria"
              optionsArray={['', '999 | 9999 | 9999-9 | Caixinha']}
              widthPercentage="50%"
            />
            <InputCheckBox title="Todas" id="Todas" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Dados"
              id="Dados"
              optionsArray={['', 'Realizado', 'Previsto', 'Todos']}
              widthPercentage="50%"
            />
            <InputCheckBox title="Destacar Previsto/Realizado" id="Destacar" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions
              title="Vencidas antes do período"
              id="VencidasAntesDoPeriodo"
              optionsArray={['', 'Não', 'Contas à Receber', 'Contas à Pagar', 'Todas']}
              widthPercentage="50%"
            />
            <InputCheckBox title="Visualizar Gráfico" id="Visualizar" />
          </WrapperInputsNewSystem>
          <ButtonsSearch />
        </div>
      </ContainerSection>
    </div>
  );
}
